import React from 'react';

import BlogPostEdit from '../../../components/Admin/BlogPosts/BlogPostEdit/BlogPostEdit.module';

function BlogPostNewView() {
  return (
    <BlogPostEdit />
  );
}

export default BlogPostNewView; 